import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import { handleLongText } from "../../config/global";
import { setLoading } from "../../core/feature/config/configSlice";
import { setLanguage } from "../../core/feature/language/languageSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { credentialCheck } from "../../core/service/api";
import { comboStudentsClass } from "../../core/service/api_pickup_student";
import { i18n } from "../../translations/i18n";
import Config from "../../config/Config";
import userIcon from "../../assets/images/icon_profile/user.svg";
const PickupStudentMobile = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isToken, setIsToken] = useState<any>(false);
  const [dataUser, setDataUser] = useState([]);
  const [users, setUsers] = useState(
    JSON.parse(String(localStorage.getItem("user_redux")))
  );

  const env = Config.BaseUrlDev;
  const navigate = useNavigate();

  useEffect(() => {
    try {
      if (location.pathname.split("/")[2] != undefined) {
        setIsToken(true);
        dispatch(setToken(location.pathname.split("/")[2]));
        credentialCheck().then((resCredential) => {
          dispatch(setUser(resCredential.data.user));
          getData();
        });
        if (location.pathname.split("/")[3] != undefined) {
          var lang = location.pathname.split("/")[3];
          i18n.changeLanguage(lang);
          dispatch(setLanguage(lang));
        }
      }
    } catch (error) {}
  }, [location.pathname.split("/")[2]]);

  function getData() {
    let temp = JSON.parse(String(localStorage.getItem("user_redux")));
    if (temp) {
      temp = temp.accounts[0].callerIdentities;
      console.log(temp);
      setDataUser(temp);
    }
  }
  useEffect(() => {
    if (users) {
      getData();
    }
  }, [users]);

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }
  return (
    <>
      <div className="relative min-h-screen h-full z-50 bg-psp-primary pb-10">
        <div className="min-h-screen h-full mb-6 px-4 py-6 bg-psp-primary top-to-bottom">
          <section className="mt-1 flex flex-col gap-3">
            {dataUser.map((item: any, index: number) => {
              return (
                <div
                  className="flex flex-row z-10 h-24 bg-white w-full rounded-3xl"
                  key={index}
                >
                  <div className="relative w-20 h-20 bg-gray-200 my-auto rounded-xl ml-3">
                    {item.photoUrl && (
                      <img
                        src={getImgContent(item.photoUrl)}
                        alt=""
                        className="relative w-20 object-cover h-20"
                      />
                    )}
                    {!item.photoUrl && (
                      <img
                        src={userIcon}
                        alt=""
                        className="w-20 p-1 object-cover h-20"
                      />
                    )}
                  </div>
                  <div className="flex flex-row justify-between w-full">
                    <div className="flex flex-col px-3 justify-center">
                      <h1
                        className={`font-montserrat m-0 font-medium text-sm ${
                          item.active ? "text-black" : "text-gray-500"
                        }`}
                      >
                        {item.name.length > 15
                          ? item.name.slice(0, 16) + "..."
                          : item.name}
                      </h1>
                      <h1
                        style={{ fontSize: 11 }}
                        className={`font-montserrat m-0 font-normal ${
                          item.active ? "text-black" : "text-gray-500"
                        }`}
                      >
                        {item.title}: {item.callerId}
                      </h1>
                    </div>
                    <div className="my-auto mr-3">
                      <button
                        className="bg-psp-btn-primary py-2 px-4 rounded-lg  text-white font-bold text-xs"
                        onClick={() => {
                          localStorage.setItem("accountId", item.id);
                          navigate("/medical-record/report", {
                            state: {
                              data: item.id,
                            },
                          });
                        }}
                      >
                        Detail
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </section>
        </div>
      </div>
    </>
  );
};

export default PickupStudentMobile;
